const SetNxProperties = "SetNxProperties"
const GetNxProperties = "GetNxProperties"
const ForceContent = "ForceContent"
const SetContent = "SetContent"
const GetRawContent = "GetRawContent"
const GetContent = "GetContent"
export { GetContent };
export { GetRawContent };
export { SetContent };
export { ForceContent };
export { GetNxProperties };
export { SetNxProperties };